export default "__VITE_ASSET__1c0c46db__"